module.exports = __webpack_public_path__ + "img/kraken-white.7d5ee62a.png";